import React, { useContext, useState  } from "react";
import "./gallery.css";
import { MdOutlineInsertPhoto } from "react-icons/md";
import { RxVideo } from "react-icons/rx";
import { LanguageContext } from "../settings/LanguageContext";

import homegallery1 from "../photos/homegallery1.png";
import homegallery2 from "../photos/homegallery2.png";
import homegallery3 from "../photos/homegallery3.png";
import homegallery4 from "../photos/homegallery4.png";
import homegallery5 from "../photos/homegallery5.png";
import homegallery6 from "../photos/homegallery6.png";

const galleryp = [
  {id:1,photo:homegallery1,name:"Lori Region",place:"Nature",type: "photo" },
  {id:2,photo:homegallery2,name:"Noravank Monastery",place:"Culture",type: "photo" },
  {id:3,photo:homegallery3,name:"Trchkan Waterfall",place:"Nature",type: "photo" },
  {id:4,photo:homegallery4,name:"Garni Temple",place:"Culture",type: "photo" },
  {id:5,photo:homegallery5,name:"Tavush Region",place:"Nature",type: "photo" },
  {id:6,photo:homegallery6,name:"Tatev Monostery",place:"Culture",type: "photo" },
  {id:7,photo:homegallery1,name:"Lori Region",place:"Nature",type: "photo" },
  {id:8,photo:homegallery2,name:"Noravank Monastery",place:"Culture",type: "photo" },
  {id:9,photo:homegallery3,name:"Trchkan Waterfall",place:"Nature",type: "photo" },
  {id:10,photo:homegallery4,name:"Garni Temple",place:"Culture",type: "photo" },
  {id:11,photo:homegallery5,name:"Tavush Region",place:"Nature",type: "photo" },
  {id:12,photo:homegallery6,name:"Tatev Monostery",place:"Culture",type: "photo" },
];

const Gallery = () => {
  const { lang } = useContext(LanguageContext);
  const [activeTab, setActiveTab] = useState("photo");


  return (
    <div className="main-galler">
      <div className="gallery-top">
        <span className="gallery-title-explore">
          {lang === "EN"
            ? "Explore our gallery to discover the beauty of Armenia."
            : "Исследуйте нашу галерею, чтобы открыть для себя красоту Армении."}
        </span>
      </div>
<div className="discover-bottom-buttuns">
  <div
    className={`discover-bottom-btn ${activeTab === "photo" ? "active" : ""}`}
    onClick={() => setActiveTab("photo")}
  >
    <MdOutlineInsertPhoto size={24} color="#2176FF" />{" "}
    {lang === "EN" ? "Photos" : "Фотографии"}
  </div>

  <div
    className={`discover-bottom-btn ${activeTab === "video" ? "active" : ""}`}
    onClick={() => setActiveTab("video")}
  >
    <RxVideo size={24} color="#2176FF" />{" "}
    {lang === "EN" ? "Videos" : "Видео"}
  </div>
</div>

      <div className="main-homegallery">
        <div className="homegallery-container">
          <div className="gallery-random-span">
            <span className="explore-gallery-tex">
              {lang === "EN"
                ? "Explore our gallery to discover the beauty of Armenia"
                : "Исследуйте нашу галерею, чтобы открыть для себя красоту Армении"}
            </span>
          </div>

          <div className="homegallery-photos">
  {galleryp
    .filter(item => item.type === activeTab)
    .map((item) => (
      <div key={item.id} className="homegallery-item">
        <img src={item.photo} alt={item.name} />
        <div className="overlay">
          <p className="homegallery-tour-phototext">
            {item.name} <br /> {item.place}
          </p>
        </div>
      </div>
    ))}
</div>

          <div className="tour-buttons">
            <button className="tour-button-page">1</button>
            <button className="tour-button-page">2</button>
            <button className="tour-button-page">3</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Gallery;
